export const useStoreVideos = defineStore('StoreVideos', {
    state: () => ({
        videos: null,
        error: null,
        filter: {
            paginate: {
                auto: false,
            },
            order: [
                {field: 'video_date_taken', asc: false},
                {field: 'video_division', asc: true},
                {field: 'video_format', asc: true},
                {field: 'video_placing', asc: true},
                {field: 'id_dancer', asc: false},
                {field: 'video_title', asc: true},
            ],
        },
    }),
    actions: {
        async initVideos() {
            if (this.videos) return Promise.resolve(this.videos);
            return this.getVideos();
        },
        async getVideos() {
            this.error = null;
            ({videos: this.videos, error: this.error} = await useQueryVideos().get(this.filter));
        },
    },
    getters: {
        searchVideos() {
            return ({videoTitle}) => {
                if (!this.videos) return [];
                return this.videos.filter(
                    (video) => video.video_title && video.video_title.toLowerCase().includes(videoTitle.toLowerCase()),
                );
            };
        },
    },
});
